import React from 'react';
import { Box, Container, Typography } from '@mui/material';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
}

// This component has been completely rewritten to match src/pages/Over.tsx styling
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle }) => {
  return (
    <Box sx={{ 
      bgcolor: '#BEB4A7', // Taupe background (matches Over page's primary.dark)
      color: 'white',
      py: 6 // Padding top/bottom like Over page
    }}>
      <Container maxWidth="lg">
        <Typography 
          variant="h1" 
          gutterBottom 
          sx={{ 
            fontSize: { xs: '2.5rem', md: '3rem' },
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 500,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography 
            variant="h2" 
            sx={{ 
              fontSize: '1.25rem', 
              mb: 0, 
              opacity: 0.9,
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 300,
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Container>
    </Box>
  );
};

export default PageHeader; 